/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OicLicenseInput } from '../../models/oic-license-input';
import { OicLicenseOutput } from '../../models/oic-license-output';

export interface ApiOicCheckMultiplePost$Params {
      body?: Array<OicLicenseInput>
}

export function apiOicCheckMultiplePost(http: HttpClient, rootUrl: string, params?: ApiOicCheckMultiplePost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OicLicenseOutput>>> {
  const rb = new RequestBuilder(rootUrl, apiOicCheckMultiplePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OicLicenseOutput>>;
    })
  );
}

apiOicCheckMultiplePost.PATH = '/api/Oic/CheckMultiple';
